export interface CardColors {
    text: string;
    background: string;
    red: string;
    pink: string;
}

export type TemplateKeys = 'Workwear' | 'Healthcare';

export const colors: Record<TemplateKeys, CardColors> = {
    Workwear: {
        background: '#fff',
        text: '#000',
        red: '#ee1b52',
        pink: '#f378c4'
    },
    Healthcare: {
        background: '#fff',
        text: '#000',
        red: '#ee1b52',
        pink: '#f378c4'
    }
}